import appLogger from "../../utils/app-logger";
import EventServiceApi from "../../services/event-service-api";
import userServiceApi from "../../services/user-service-api";

const forgotPasswordAtempt = (data) => {
  return userServiceApi
    .forgotPasswordAtempt(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Error");
      return error;
    });
};

const generateResetToken = (data) => {
  return userServiceApi
    .postEvent(data)
    .then((response) => {
      return response;
    })
    .catch((error) => console.log("Error"));
};

export { forgotPasswordAtempt };
